interface BrazzaBoostLogoProps {
  className?: string;
}

export const BrazzaBoostLogo = ({ className = "" }: BrazzaBoostLogoProps) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Text */}
      <span 
        className="text-2xl font-bold tracking-wide"
        style={{ 
          color: '#2ECC71',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          letterSpacing: '0.05em'
        }}
      >
        BRAZZABOOST
      </span>
      
      {/* Icon - 3D double arrows */}
      <svg 
        viewBox="0 0 48 48" 
        className="h-9 w-9"
        fill="none"
      >
        {/* Top arrow - solid dark green */}
        <polygon 
          points="4,8 24,18 24,14 44,4 44,8 24,18 24,22 4,12"
          fill="#27AE60"
        />
        <polygon 
          points="24,14 44,4 44,8 24,18"
          fill="#1E8449"
        />
        <polygon 
          points="4,8 24,14 24,18 4,12"
          fill="#2ECC71"
        />
        
        {/* Bottom arrow - lighter green with 3D effect */}
        <polygon 
          points="4,28 24,38 24,34 44,24 44,28 24,38 24,42 4,32"
          fill="#58D68D"
        />
        <polygon 
          points="24,34 44,24 44,28 24,38"
          fill="#27AE60"
        />
        <polygon 
          points="4,28 24,34 24,38 4,32"
          fill="#82E0AA"
        />
        
        {/* Bottom arrow outline stroke */}
        <path 
          d="M4,28 L24,38 L44,28 M24,38 L24,42 L4,32"
          stroke="#A9DFBF"
          strokeWidth="1"
          fill="none"
        />
      </svg>
    </div>
  );
};
